import utils from 'utils'
import imageSynchronizationPage from './view/imageSynchronizationPage.html'
class imageManagementCtrl {
    constructor($scope, logger, httpRequest, initSortService, globalFn, $filter, $uibModal, sweetalert) {
        $scope.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
        // 所勾选初始的数据
        $scope.selectedRows = []
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                invoiceTypeList: [],
                // invoiceCode: '',
                // invoiceDateStart: '',
                // invoiceDateEnd: '',
                // collectionDateStart: '',
                // collectionDateEnd: '',
                // taxRate: '',
                // adValoremTotalStart: '',
                // createUser: '',
                // invoiceStatus: '',
                // invoiceSource: '',
                // saleName: '',
                // saleCreditCode: '',
                // userName: '',
                // destination: '',
                // departure: '',
                // deductionFlag: '',
                // passengerFlag: '',
                // claimNumber: '',
                // collectionStatus: '',
                // turnOutType: '',
                usagePage: 4,
                // zcssq: '',
                // dkssq: '',
                // projectName: '',
                // projectCode: '',
                // transferOutSign: '',
                // transferAmount: '',
                orgIdList: $scope.orgIdListArr,
            },
        }
        const startDate = new Date()
        startDate.setFullYear(startDate.getFullYear() - 1)
        $scope.datePickerConfig1 = {
            //   startDate,
            //   endDate: new Date(),
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
            clearBtn: true, //清除按钮
        }
        // 字典数据
        $scope.dictData = {}
        const typecodeArr = [
            'department_no', //事业部
            'interface_source_system',
            'ivat_inv_type',
            'ivat_image_type',
            'interface_invoice_status',
            'ivat_source_app_id',
        ]
        function get_dictByTypeArr() {
            return httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
                return res.data.value
            })
        }
        // 对票据种类查询改造 适应树组件
        $scope.billTypeSearch = (billType) => {
            // 默认查询全部票据种类
            let billTypeId = []
            billType.forEach((item) => {
                item.orgName = item.enumName
                item.orgId = item.enumCode
                item.checked = false
                item.open = true
            })
            $scope.billTypeList = billType
            $scope.selectedBillTypeList = []
            $scope.param.param.invoiceTypeList = billTypeId
        }
        $scope.handleBillTypeChange = (billTypeData) => {
            $scope.param.param.invoiceTypeList = billTypeData.map((item) => {
                return item.orgId
            })
        }
        // 主管税局省（市）
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 联动查询管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                return v.enumName === enumName
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                return v.regionName === enumName
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        // 重置
        $scope.reset = function () {
            $scope.param.param = {
                usagePage: 4,
                orgIdList: $scope.orgIdListArr,
            }
            $scope.belleRegionCityList = []
            $scope.$broadcast('selectedOrgList', $scope.selectedOrgList)
            getUserOrgList()
            $scope.$broadcast('billTypeList', $scope.billTypeList)
        }
        // 查询展开
        $scope.isFilterCollapsed = false
        $scope.customizedConfig = {
            version: 5.6,
            queryConfig: [
                {
                    label: '机构名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '业务单据号',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '来源系统',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '影像类别',
                    selected: true,
                    default: true,
                },
                {
                    label: '入账月份',
                    selected: true,
                    default: true,
                },
                {
                    label: '事业部',
                    selected: true,
                    default: true,
                },
                {
                    label: '所属大区',
                    selected: true,
                    default: true,
                },
                {
                    label: '管理城市',
                    selected: true,
                    default: true,
                },
                {
                    label: '数电票号码',
                    selected: true,
                    default: true,
                },{
                    label: '来源系统编码',
                    selected: true,
                    default: true,
                },
            ],
            table: [
                {
                    label: '业务单据号',
                    selected: true,
                    default: true,
                },
                {
                    label: '报销状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '来源系统',
                    selected: true,
                    default: true,
                },
                {
                    label: '关联单据号',
                    selected: true,
                    default: true,
                },
                {
                    label: '凭证号',
                    selected: true,
                    default: true,
                },
                {
                    label: '机构名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '事业部',
                    selected: true,
                    default: true,
                },
                {
                    label: '所属大区',
                    selected: true,
                    default: true,
                },
                {
                    label: '管理分区',
                    selected: true,
                    default: true,
                },
                {
                    label: '管理城市',
                    selected: true,
                    default: true,
                },
                {
                    label: '主管税局所在省市',
                    selected: true,
                    default: true,
                },
                {
                    label: '入账月份',
                    selected: true,
                    default: true,
                },
                {
                    label: '账套编码',
                    selected: true,
                    default: true,
                },
                {
                    label: '影像ID',
                    selected: true,
                    default: true,
                },
                {
                    label: '影像类别',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '创建日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '创建人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '更新日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '更新人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '流程申请人',
                    selected: true,
                    default: true,
                },
                {
                    label: '数电票号码',
                    selected: true,
                    default: true,
                },{
                    label: '来源系统编码',
                    selected: true,
                    default: true,
                },
            ],
        }
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数

        $scope.pageChanged = function () {
            // 点击页码发起查询
            queryInfo()
        }

        function queryInfo() {
            $scope.selectedRows = []
            const openLoading =
                $scope.param.pageSize >= 100
                    ? window.layer.msg('正在查询，请耐心等待', {
                          time: 0,
                          skin: 'layer-loading-self',
                          icon: 16,
                          shade: 0.5,
                      })
                    : null
            httpRequest
                .post_selectPageBill($scope.param)
                .then((res) => {
                    $scope.listData = res.data.value.list
                    // 获取后台分页数据 回写分页组件
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.currentPage = ++res.data.value.prePage
                    $scope.param.pageSize = res.data.value.pageSize
                })
                .finally(() => {
                    window.layer.close(openLoading)
                })
        }

        $scope.searchlist = function () {
            queryInfo()
        }
        //机构树的check配置信息
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
                chkStyle: 'checkbox',
            },
        }
        async function getUserOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                if (res.data.success) {
                    $scope.orgList = res.data.value
                    // 机构勾选变化
                    $scope.orgIdListArr = []
                    // 展开节点及全选
                    angular.forEach($scope.orgList, function (item, index) {
                        item.open = true
                        if ($scope.currentOrgId == item.orgId) {
                            item.checked = true
                            $scope.orgIdListArr.push(item.orgId)
                            // 默认当前操作机构
                            $scope.selectedOrgList = [item]
                        }
                    })
                    $scope.param.param.orgIdList = $scope.orgIdListArr
                    // 返回机构名称
                    $scope.fliterOrgName = function (id) {
                        if (id === null) {
                            return id
                        }
                        if (res.data.value === null) {
                            return id
                        }
                        const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                        if (fliterUkeyNameArr.length > 0) {
                            return fliterUkeyNameArr[0].orgName
                        }
                        return id
                    }
                }
                // 需先获取机构参数在查询 异步问题
                get_dictByTypeArr().then((res) => {
                    $scope.dictData = $.extend($scope.dictData, res)
                    $scope.billTypeSearch($scope.dictData.ivat_inv_type)
                    queryInfo()
                })
            })
        }
        getUserOrgList()
        // 所选择的机构名称
        $scope.handleOrgChange = function (orgData) {
            //重置
            $scope.orgIdListArr = []
            if (orgData.length > 0) {
                angular.forEach(orgData, function (item, index) {
                    $scope.orgIdListArr.push(item.orgId)
                })
                $scope.param.param.orgIdList = $scope.orgIdListArr
            } else {
                $scope.orgIdListArr = []
                $scope.param.param.orgIdList = $scope.orgIdListArr
            }
        }
        // 是否全选机构
        $scope.orgIsCheckAll = (orgList) => {
            let orgListArr = []
            angular.forEach(orgList, (item, index) => {
                orgListArr.push(item.orgId)
            })
            $scope.param.param.orgIdList = orgListArr
        }
        // 是否全选票据种类
        $scope.billTypeIsCheckAll = (billTypeList) => {
            let billTypeListArr = []
            angular.forEach(billTypeList, (item, index) => {
                billTypeListArr.push(item.orgId)
            })
            $scope.param.param.invoiceTypeList = billTypeListArr
        }
        $scope.imageUrl = function (id, num) {
            let imageId = id ? id : ''
            let claimNumber = num ? num : ''
            let url = `${host.etcloudImage}Preview?id=${imageId}&claimNumber=${claimNumber}&sid=3018&accessToken=${localStorage.getItem('id_token')}`
            window.open(url, '_blank')
        }
        // 下载源文件
        $scope.downloadSourceFile = () => {
            const selectedRows = $scope.selectedRows
            if (selectedRows.length === 0) {
                return logger.logError('请选择要下载的数据行')
            }
            let invoiceIds = []
            try {
                selectedRows.forEach((item) => {
                    if (item.invoiceType != '51' && item.invoiceType != '08' && item.invoiceType != '14' && item.invoiceType != '61' && item.invoiceType != '62' && item.invoiceType != '111') {
                        throw new Error('break')
                    }
                    if (item.imageType != '1') {
                        throw new Error('仅支持影像类别为发票的电子发票下载源文件，请检查!')
                    }
                    invoiceIds.push(item.invoiceId)
                })
            } catch (e) {
                return logger.logError('仅支持电子发票源文件下载，请检查!')
            }
            httpRequest.get_downloadInvoiceSourceFile({
                invoiceIds: invoiceIds.join(','),
                accessToken: localStorage.getItem('id_token'),
            })
        }
        $scope.imageSynchronization = () => {
            //如果有勾选数据，只能单条同步，向接口传入发票id，不用弹窗选择日期
            const selectedRows = $scope.selectedRows
            if (selectedRows.length && selectedRows.length == 1) {
                httpRequest.post_syncInvoice2System(
                    {
                        invoiceId: selectedRows[0].invoiceId,
                    },
                    '影像同步成功'
                )
            } else if (!selectedRows.length) {
                const modalInstance = $uibModal.open({
                    template: imageSynchronizationPage,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        'items1',
                        function ($scope, $uibModalInstance, logger, items1) {
                            // $scope.modalData = items1;
                            $scope.param = {
                                billDateStart: utils.getMonthFirstLast().firstDate1,
                                billDateEnd: utils.getMonthFirstLast().lastDate1,
                            }
                            $scope.cancel = () => {
                                $uibModalInstance.dismiss()
                            }
                            function checkDateRange(startDate, endDate) {
                                // 将起止日期转换为时间戳
                                let startTimestamp = Date.parse(startDate)
                                let endTimestamp = Date.parse(endDate)

                                // 计算时间差（以天为单位）
                                let dayDiff = Math.abs((endTimestamp - startTimestamp) / (1000 * 60 * 60 * 24))

                                // 判断时间差是否小于等于30天
                                if (dayDiff <= 30) {
                                    return true
                                } else {
                                    return false
                                }
                            }
                            // 关闭
                            $scope.ok = () => {
                                if (!checkDateRange($scope.param.billDateStart, $scope.param.billDateEnd)) return logger.logError('单据日期起止时间不能超过30天，请检查！')
                                $uibModalInstance.close($scope.param)
                            }
                        },
                    ],
                    backdrop: 'static',
                    openedClass: 'mod-modal-importexcel',
                    windowClass: 'mod-modal mod-modal-lg',
                    bindToController: true,
                    resolve: {
                        items1() {
                            // return modalData;
                        },
                    },
                })
                modalInstance.result.then(
                    (data) => {
                        httpRequest.post_syncInvoice2System(data, '影像同步成功').then((res) => {})
                    },
                    () => {}
                )
            } else {
            }
        }
    }
}
imageManagementCtrl.$inject = ['$scope', 'logger', 'httpRequest', 'initSortService', 'globalFn', '$filter', '$uibModal', 'sweetalert']
export default imageManagementCtrl



// WEBPACK FOOTER //
// ./src/app/input/electronImage/imageManagement/imageManagementCtrl.js